import classNames from "classnames"
import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import {
  capitalizeFirstLetter,
  inchesToFeet,
  isPresent,
} from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

class FootageSelectionTool extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.startLocationFeet = inchesToFeet(props.space.start_location)
    this.endLocationFeet = inchesToFeet(props.space.end_location)
    this.bufferSizeFeet = inchesToFeet(props.spaceGroup.buffer_size)
    this.boatLengthFeet = inchesToFeet(props.contactBoat.length_overall)
    this.bowLocation = inchesToFeet(props.assignment.bow_location)
    this.sternLocation = inchesToFeet(props.assignment.stern_location)
    this.totalChunkLengthFeet =
      inchesToFeet(props.space.end_location) -
      inchesToFeet(props.space.start_location)
    this.state = {
      openSpace: {
        id: props.id,
        space: props.space,
        open: false,
      },
      tieSide: props.tieSide,
      startOfDock: props.space.start_location === 0,
      endOfDock: props.space.end_location === props.spaceGroup.total,
      warningMessage: !props.space.available
        ? "Boat is outside available footage"
        : "",
      validationMessage: "",
      flipped: props.tieSide === "port",
      editingSpace: props.editingSpace,
      bowLocation: this.setLocation(props, "bow"),
      sternLocation: this.setLocation(props, "stern"),
      boatPosition1: this.setPosition(props, 1),
      boatPosition2: this.setPosition(props, 2),
    }
    this.bowImgUrl = $context.bowImgUrl
    this.sternImgUrl = $context.sternImgUrl
    this.toggleOpen = this.toggleOpen.bind(this)
    this.renderFootageSelectionTool = this.renderFootageSelectionTool.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.flipSide = this.flipSide.bind(this)
    this.setSpace = this.setSpace.bind(this)
    this.addBufferStart = this.addBufferStart.bind(this)
    this.addBufferEnd = this.addBufferEnd.bind(this)
    this.renderValidationMessages = this.renderValidationMessages.bind(this)
    this.validator = validatorFactory({ autoForceUpdate: this })
  }

  componentDidMount() {
    this.validator.showMessages()
  }

  spaceStartLocation() {
    return this.addBufferStart(inchesToFeet(this.props.space.start_location))
  }

  boatEndLocation() {
    return this.addBufferStart(
      inchesToFeet(
        this.props.space.start_location + this.props.contactBoat.length_overall
      )
    )
  }

  assignmentBowLocation() {
    return inchesToFeet(this.props.assignment.bow_location)
  }

  assignmentSternLocation() {
    return inchesToFeet(this.props.assignment.stern_location)
  }

  assignmentLocation() {
    return [this.assignmentBowLocation(), this.assignmentSternLocation()]
  }

  boatInSpaceLocation() {
    return [this.spaceStartLocation(), this.boatEndLocation()]
  }

  setLocation(props, end) {
    let location
    if (
      isPresent(props.assignment.bow_location) &&
      this.checkIfEditing(props.space)
    ) {
      location = this.assignmentLocation()
    } else if (props.tieSide === "starboard") {
      location = this.boatInSpaceLocation()
    } else {
      location = this.boatInSpaceLocation().reverse()
    }
    return end === "bow" ? location[0] : location[1]
  }

  setPosition(props, position) {
    let location
    if (
      isPresent(props.assignment.bow_location) &&
      this.checkIfEditing(props.space)
    ) {
      location = this.assignmentLocation()
      if (props.tieSide === "starboard") {
        location = this.boatInSpaceLocation()
      } else {
        location = this.boatInSpaceLocation().reverse()
      }
    } else {
      location = this.boatInSpaceLocation()
    }
    return position === 1 ? location[0] : location[1]
  }

  spaceRangeId() {
    return `${this.props.space.id}-${this.state.openSpace.space.start_location}-${this.state.openSpace.space.end_location}`
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.bufferFilter !== prevProps.bufferFilter &&
      !this.state.startOfDock
    ) {
      if (
        this.startLocationFeet + this.bufferSizeFeet ===
          this.state.boatPosition1 ||
        this.startLocationFeet === this.state.boatPosition1
      ) {
        this.setState({
          boatPosition1: this.addBufferStart(this.startLocationFeet),
          boatPosition2: this.addBufferStart(
            this.startLocationFeet + this.boatLengthFeet
          ),
          bowLocation:
            this.props.tieSide === "starboard"
              ? this.addBufferStart(this.startLocationFeet)
              : this.addBufferStart(
                  this.startLocationFeet + this.boatLengthFeet
                ),
          sternLocation:
            this.props.tieSide === "port"
              ? this.addBufferStart(this.startLocationFeet)
              : this.addBufferStart(
                  this.startLocationFeet + this.boatLengthFeet
                ),
        })
      }
    }
    if (
      this.state.openSpace.open !== prevState.openSpace.open &&
      this.state.openSpace.id === this.props.id
    ) {
      const footageTool = document.getElementById(this.spaceRangeId())
      const quickAssignWindow = document.getElementById("quickAssignWindow")
      const sideBarWindow = document.getElementById("sideBarWindow")
      if (this.state.openSpace.open) {
        // if the distance of the footage tool from the top minus the distance of the quickAssignWindow scroll bar is greater than 947
        if (footageTool.offsetTop - quickAssignWindow.scrollTop > 947) {
          // if the outer sideBarWindow scroll bar is less than double the height of the footage tool
          if (sideBarWindow.scrollTop < footageTool.scrollHeight * 2) {
            // scroll the outer sideBarWindow from the top, a distance equal to the distance of the sideBarWindow scroll bar from the top plus the height of the footage tool
            sideBarWindow.scrollTo({
              top: sideBarWindow.scrollTop + footageTool.scrollHeight,
              behavior: "smooth",
            })
          } else {
            // otherwise scroll the inner quickAssignWindow from the top, a distance equal to the distance of the quickAssignWindow scroll bar fromt he top plus the height of the footage tool
            quickAssignWindow.scrollTo({
              top: quickAssignWindow.scrollTop + footageTool.scrollHeight,
              behavior: "smooth",
            })
          }
          // if the distance of the outer sideBarWindow scroll bar is less than double the height of the footage tool
        } else if (sideBarWindow.scrollTop < footageTool.scrollHeight * 2) {
          // scroll the outer sideBarWindow from the top, a distance equal to the distance of the sideBarWindow scroll bar from the top plus the height of the footage tool
          sideBarWindow.scrollTo({
            top: sideBarWindow.scrollTop + footageTool.scrollHeight,
            behavior: "smooth",
          })
        }
      }
    }
  }

  addBufferStart(item) {
    if (this.props.bufferFilter && this.props.space.start_location > 0) {
      return parseInt(item) + this.bufferSizeFeet
    } else {
      return item
    }
  }

  checkIfEditing(space) {
    return (
      this.props.assignment &&
      this.props.assignment.space_id === space.id &&
      this.props.rangeIndex === this.props.id
    )
  }

  renderRange(space) {
    const spaceEndLocation = this.addBufferEnd(this.endLocationFeet)
    const spaceStartLocation = this.addBufferStart(this.startLocationFeet)
    if (spaceEndLocation - spaceStartLocation > 0) {
      return (
        <div
          key={`space-${this.props.id}`}
          className={classNames(
            "hover:bg-gray cursor-pointer rounded p-1 pl-2",
            { "border-green border border-dashed": this.checkIfEditing(space) }
          )}
          onClick={() => this.toggleOpen(space)}
        >
          {space.available ? (
            <i className="icon icon-circle-check-solid icon-fw text-status-green mr-2" />
          ) : (
            <i
              className="icon icon-cancel icon-fw mr-2"
              style={{ color: "#cecece" }}
            />
          )}
          <span
            className={classNames({
              "font-semibold": space.available,
              "text-muted": !space.available,
            })}
          >
            {spaceStartLocation}&apos; - {spaceEndLocation}&apos;
            <i
              className={classNames(
                "icon icon-chevron transition duration-100",
                {
                  "icon-rotate-90":
                    this.state.openSpace.id === this.props.id &&
                    this.state.openSpace.open,
                }
              )}
            />
          </span>
        </div>
      )
    }
  }

  addBufferEnd(item) {
    if (
      this.props.bufferFilter &&
      this.props.space.end_location < this.props.spaceGroup.total
    ) {
      return parseInt(item) - this.bufferSizeFeet
    } else {
      return item
    }
  }

  toggleOpen(space) {
    this.setState({
      openSpace: {
        id: this.props.id,
        space,
        open: !this.state.openSpace.open,
      },
    })
  }

  calculateBoatImgSize() {
    return (this.boatLengthFeet / this.totalChunkLengthFeet) * 100 - 7
  }

  calculateBoatStartPoint() {
    if (
      this.state.boatPosition1 <= this.addBufferStart(this.startLocationFeet)
    ) {
      return 0
    } else if (
      this.state.boatPosition2 >= this.addBufferEnd(this.endLocationFeet)
    ) {
      return 90
    } else {
      return (
        ((this.state.boatPosition1 -
          this.addBufferStart(this.startLocationFeet)) /
          this.totalChunkLengthFeet) *
        100
      )
    }
  }

  getOppositeTieSide(tieSide) {
    return tieSide === "port" ? "starboard" : "port"
  }

  flipSide() {
    this.setState({
      tieSide: this.getOppositeTieSide(this.state.tieSide),
      flipped: !this.state.flipped,
      bowLocation: this.state.sternLocation,
      sternLocation: this.state.bowLocation,
    })
  }

  setSpace(spaceId) {
    this.validator.showMessages()
    if (!isNaN(this.state.boatPosition1)) {
      Amplitude.trackEvent("assignments:assigned_linear_dockage_v2")
      this.setState({ editingSpace: false, validationMessage: "" }, () =>
        this.props.setAssignmentFormState({
          editingSpace: false,
          bowLocation: this.state.bowLocation,
          sternLocation: this.state.sternLocation,
          selectingAssignment: false,
        })
      )
      this.props.assignmentChange(
        "space_id",
        spaceId,
        this.props.assignmentFormIndex,
        this.state.bowLocation,
        this.state.sternLocation
      )
    } else {
      this.setState({ validationMessage: "Enter a valid number" })
    }
  }

  calculateOverhang(selectedPosition, boatLengthFeet, endLocationFeet) {
    let startOverhang = 0
    let endOverhang = 0

    if (this.state.startOfDock && selectedPosition < 0) {
      startOverhang = 0 - selectedPosition
    }

    if (
      this.state.endOfDock &&
      selectedPosition + boatLengthFeet > endLocationFeet
    ) {
      endOverhang = selectedPosition + boatLengthFeet - endLocationFeet
    }

    return startOverhang + endOverhang
  }

  handleInputChange(event) {
    this.validator.showMessages()
    if (event.target.value) {
      // if the space isn't available, warn the user that the boat is outside of available footage, but still can be assigned
      if (!this.state.openSpace.space.available && !isNaN(event.target.value)) {
        this.setState({
          boatPosition1: parseInt(event.target.value),
          boatPosition2:
            parseInt(event.target.value) + parseInt(this.boatLengthFeet),
          bowLocation: this.state.flipped
            ? parseInt(event.target.value) + parseInt(this.boatLengthFeet)
            : parseInt(event.target.value),
          sternLocation: this.state.flipped
            ? parseInt(event.target.value)
            : parseInt(event.target.value) + parseInt(this.boatLengthFeet),
          validationMessage: "",
          warningMessage: "Boat is outside available footage",
        })
        // case where the input is larger/less than the total available footage
      } else if (
        parseInt(event.target.value) + parseInt(this.boatLengthFeet) >
          this.addBufferEnd(this.endLocationFeet) ||
        parseInt(event.target.value) <
          this.addBufferStart(this.startLocationFeet)
      ) {
        const overhang = this.calculateOverhang(
          parseInt(event.target.value),
          parseInt(this.boatLengthFeet),
          this.endLocationFeet
        )
        const warningMessage =
          overhang > 0
            ? `There's a ${overhang}' overhang`
            : "Boat is outside available footage"
        this.setState({
          boatPosition1: parseInt(event.target.value),
          boatPosition2:
            parseInt(event.target.value) + parseInt(this.boatLengthFeet),
          bowLocation: this.state.flipped
            ? parseInt(event.target.value) + parseInt(this.boatLengthFeet)
            : parseInt(event.target.value),
          sternLocation: this.state.flipped
            ? parseInt(event.target.value)
            : parseInt(event.target.value) + parseInt(this.boatLengthFeet),
          validationMessage: "",
          warningMessage,
        })
      } else if (isNaN(event.target.value)) {
        this.setState({
          boatPosition1: event.target.value,
          boatPosition2: "",
          validationMessage: "Enter a valid number",
          warningMessage: "",
        })
      } else {
        this.validator.hideMessages()
        this.setState({
          boatPosition1: parseInt(event.target.value),
          boatPosition2:
            parseInt(event.target.value) + parseInt(this.boatLengthFeet),
          bowLocation: this.state.flipped
            ? parseInt(event.target.value) + parseInt(this.boatLengthFeet)
            : parseInt(event.target.value),
          sternLocation: this.state.flipped
            ? parseInt(event.target.value)
            : parseInt(event.target.value) + parseInt(this.boatLengthFeet),
          validationMessage: "",
          warningMessage: "",
        })
      }
    } else {
      // case where input is empty
      this.validator.hideMessages()
      this.setState({
        boatPosition1: event.target.value,
        boatPosition2: event.target.value,
        validationMessage: "",
        warningMessage: "",
      })
    }
  }

  renderValidationMessages() {
    if (this.state.validationMessage) {
      return this.validator.messageWhenPresent(this.state.validationMessage, {
        element: (message) => (
          <div className="mt-1 text-red-800">{message}</div>
        ),
      })
    } else {
      return this.validator.messageWhenPresent(this.state.warningMessage, {
        element: (message) => (
          <div className="mt-1 text-yellow-700">
            <i className="icon icon-warning-outline mr-1 text-yellow-700" />
            {message}
          </div>
        ),
      })
    }
  }

  renderFootageSelectionTool() {
    return (
      <div className="overflow-x-hidden p-2">
        <div className="flex w-full justify-between text-xs">
          <p>{this.props.spaceGroup.orientation_start}</p>
          <p>{this.props.spaceGroup.orientation_end}</p>
        </div>
        <div className="-mt-2 flex w-full justify-between text-xs">
          <p>{this.addBufferStart(this.startLocationFeet)}&apos;</p>
          <p>{this.addBufferEnd(this.endLocationFeet)}&apos;</p>
        </div>
        <div className="flex flex-col content-around">
          <div className="h-2 w-full bg-gray-400" />
          <div className="h-3 w-full bg-blue-400" />
          <div
            style={{ marginLeft: `${this.calculateBoatStartPoint()}%` }}
            className="-mt-5 flex w-full flex-row content-around"
          >
            <img
              src={this.state.flipped ? this.sternImgUrl : this.bowImgUrl}
              style={
                this.state.flipped
                  ? { height: "12px", width: "11px" }
                  : {
                      transform: "scaleX(-1)",
                      height: "19px",
                      width: "19px",
                      marginTop: "-7px",
                    }
              }
              alt="boatImg"
            />
            <div
              className="h-3 bg-gray-600"
              style={{ width: `${this.calculateBoatImgSize()}%` }}
            />
            <img
              src={this.state.flipped ? this.bowImgUrl : this.sternImgUrl}
              style={
                this.state.flipped
                  ? { height: "19px", width: "19px", marginTop: "-7px" }
                  : { transform: "scaleX(-1)", height: "12px", width: "11px" }
              }
              alt="boatImg2"
            />
          </div>
        </div>
        <div className="btn btn-ghost btn-sm mt-2.5" onClick={this.flipSide}>
          Flip to{" "}
          {capitalizeFirstLetter(this.getOppositeTieSide(this.state.tieSide))}{" "}
          tie
        </div>
        <div className="text-muted mt-1 flex text-xs">
          <p id="boatPositionLabel">
            {this.state.flipped ? "Stern" : "Bow"} Location
          </p>
          <p className="ml-6">
            {this.state.flipped ? "Bow" : "Stern"} Location
          </p>
        </div>
        <div className="-mt-1 flex w-full" style={{ zIndex: 0 }}>
          <FormGroup
            inputType="feet"
            name="boatPosition1"
            value={this.state.boatPosition1}
            className="my-0 w-20"
            ariaLabelledBy="boatPositionLabel"
            onChange={this.handleInputChange}
          />
          <p className="ml-6 mt-2">{this.state.boatPosition2} ft</p>
          <LegacyButton
            disabled={
              this.state.validationMessage ||
              !isPresent(this.state.boatPosition1)
            }
            type="primary"
            className="btn-sm ml-20 mt-2"
            onClick={() => this.setSpace(this.props.space.id)}
          >
            Assign
          </LegacyButton>
        </div>
        {this.renderValidationMessages()}
      </div>
    )
  }

  renderSpaceRanges() {
    return (
      <div>
        {this.renderRange(this.props.space)}
        <div id={this.spaceRangeId()}>
          {this.state.openSpace.id === this.props.id &&
            this.state.openSpace.open &&
            this.renderFootageSelectionTool()}
        </div>
      </div>
    )
  }

  render() {
    return isPresent(this.props.spaceName) && !this.state.editingSpace
      ? this.props.renderSpaceInput()
      : this.renderSpaceRanges()
  }
}

FootageSelectionTool.propTypes = {
  assignment: PropTypes.object.isRequired,
  assignmentChange: PropTypes.func.isRequired,
  assignmentFormIndex: PropTypes.number,
  bufferFilter: PropTypes.bool,
  contactBoat: PropTypes.object.isRequired,
  editingSpace: PropTypes.bool,
  id: PropTypes.number.isRequired,
  rangeIndex: PropTypes.number,
  renderSpaceInput: PropTypes.func,
  setAssignmentFormState: PropTypes.func.isRequired,
  setLinearSpace: PropTypes.func,
  space: PropTypes.object.isRequired,
  spaceGroup: PropTypes.object.isRequired,
  spaceName: PropTypes.string,
  tieSide: PropTypes.string.isRequired,
}

export default FootageSelectionTool
